import { BarChart } from "@mui/icons-material"
import PropTypes from "prop-types"
import { Button } from "@mui/material"

export default function GraphErrorFallback({ error, resetError }) {
  return (
    <div className="graph-wrapper">
      <div className="graph-content">
        <div className="graph-error-container">
          <div className="graph-error-background">
            <BarChart />
          </div>

          <div className="graph-error-content">
            <h3 className="graph-error-title">
              There was an error displaying the chart.
            </h3>
            <p className="graph-error-message">
              {error?.message || "Unable to load chart"}
            </p>
            <Button onClick={resetError} type="button" variant="contained" color="primary">
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

GraphErrorFallback.propTypes = {
  error: PropTypes.object,
  resetError: PropTypes.func.isRequired,
}
